import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Spinner } from "@/components/ui/spinner";
import { Center } from "@/components/ui/center";
import { GlobalState } from '@/containers/GlobalState';

import React, { useState, useEffect, useContext } from 'react';
import { MarkerType } from "reactflow";
import store from "../../../stores/store";
import Flow from "./Flow";
import ShowFlow from "./ShowFlow";
import createNewWorkflow from "../../algorithms_and_functions/backend_requests/createNewWorkflow";
import { mediaImport } from "../../algorithms_and_functions/backend_requests/mediaRequests";
import { guid7 } from "../../../containers/GlobalState";
import { produce } from "immer"
import { taskImport } from "../../../stores/mainSlice";


export default function LoadFlow({ navigation, workflow }) {

    const { inAColors } = useContext(GlobalState);
    const [flow, setFlow] = useState(null)
    const [actWorkflow, setActWorkflow] = useState()
    const [error, setError] = useState(false)
    const [edit, setEdit] = useState(true)

    useEffect(() => {
        if (workflow) {
            if (workflow.flowData) {
                const fixedWorkflow = produce(workflow, draftWorkflow => {
                    draftWorkflow.flowData.nodes.forEach(node => {
                        node.dragHandle = null
                    })
                    draftWorkflow.flowData.edges.forEach(edge => {
                        edge.style.stroke = inAColors.primary[900]
                        edge.markerEnd.color = inAColors.primary[900]
                    })
                })
                setActWorkflow(fixedWorkflow)
            } else {
                setEdit(false)
                setFlow(translateAppWorkflow(workflow, inAColors))
                setActWorkflow(workflow)
            }
        } else {
            async function backendCreateNewWorkflow() {
                const backendResponse = await createNewWorkflow()
                if (backendResponse?.id && backendResponse?.workflowData) {
                    const workflow = { ...JSON.parse(backendResponse.workflowData), id: backendResponse.id }
                    setActWorkflow(workflow)
                } else {
                    setError(true)
                }
            }

            backendCreateNewWorkflow().then()
        }
    }, [])

    const editAppWorkflow = async () => {
        const backendResponse = await createNewWorkflow(flow)
        if (backendResponse?.id && backendResponse?.workflowData) {
            const studioWorkflow = { ...JSON.parse(backendResponse.workflowData), id: backendResponse.id }

            let mediaList = []
            for (const node of studioWorkflow.flowData.nodes) {
                mediaList = mediaList.concat(node.data.media)
                if (node.data.listElementMedia) {
                    for (const elementId of Object.keys(node.data.listElementMedia)) {
                        mediaList = mediaList.concat(node.data.listElementMedia[elementId])
                    }
                }
            }

            const copyMedia = await mediaImport(backendResponse.id, actWorkflow.workflowId, mediaList.map(media => media.replace(/\..{1,4}$/, '')))
            const importMedia = copyMedia.map((media, m) => media + mediaList[m].replace(/[^\.]+/, ''))
            // console.log('MEDIAS', mediaList, copyMedia, importMedia)
            for (let node of studioWorkflow.flowData.nodes) {
                node.data.media = importMedia.splice(0, node.data.media?.length)
                if (node.data.listElementMedia) {
                    for (const elementId of Object.keys(node.data.listElementMedia)) {
                        node.data.listElementMedia[elementId] = importMedia.splice(0, node.data.listElementMedia[elementId]?.length)
                    }
                }
            }

            const importedWorkflow = produce(workflow, draftWorkflow => {
                draftWorkflow.studio = { id: backendResponse.id }
            })
            console.log('IMPORT', importedWorkflow, studioWorkflow)
            store.dispatch(taskImport({ task: importedWorkflow }))

            setActWorkflow(studioWorkflow)
            setFlow(studioWorkflow.flowData)
            setEdit(true)
        } else {
            setError(true)
        }
    }

    return (
        <View className="flex-1">
            {actWorkflow && actWorkflow.id ?
                edit ?
                    <Flow navigation={navigation} workflow={actWorkflow} />
                    :
                    <ShowFlow navigation={navigation} flow={flow} editAppWorkflow={editAppWorkflow} allowEdit={actWorkflow?.owned && actWorkflow?.id?.length > 1} />
                :
                error ?
                    <Center><Text>Error</Text></Center>
                    :
                    <Center><Spinner /></Center>
            }
        </View>
    );
}

function translateAppWorkflow(workflow, inAColors) {
    let translatedFlow = {
        nodes: [
            {
                id: 'startOfWorkflow',
                data: {
                    title: workflow.title,
                    description: workflow.text,
                    media: workflow.media.filter(media => typeof media != 'string' || !media.startsWith('file://')),
                    nodeType: 'workflowStartNode',
                    updateNode: () => { },
                    disabled: true
                },
                deletable: false,
                position: { x: 0, y: 250 },
                type: 'workflowStartNode',
            },
            {
                id: 'endOfWorkflow',
                data: {
                    title: '',
                    description: '',
                    media: [],
                    nodeType: 'endNode',
                    updateNode: () => { },
                    disabled: true
                },
                deletable: false,
                position: { x: workflow.steps.length * 360 + 360, y: 250 },
                type: 'endNode',
            }
        ],
        edges: []
    }

    if (workflow?.steps?.length > 0) {
        translatedFlow.edges.push({
            id: 'reactflow__edge-' + guid7(),
            source: 'startOfWorkflow',
            target: '0',
            sourceHandle: 'output',
            targetHandle: 'input',
            type: 'smoothstep',
            style: { strokeWidth: 2, stroke: inAColors.primary[900] },
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,
                height: 20,
                color: inAColors.primary[900],
            }
        })
    } else {
        translatedFlow.edges.push({
            id: 'reactflow__edge-' + guid7(),
            source: 'startOfWorkflow',
            target: 'endOfWorkflow',
            sourceHandle: 'output',
            targetHandle: 'input',
            type: 'smoothstep',
            style: { strokeWidth: 2, stroke: inAColors.primary[900] },
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,
                height: 20,
                color: inAColors.primary[900],
            }
        })
    }

    for (let i = 0; i < workflow.steps.length; i++) {
        const step = workflow.steps[i]
        let edge = {
            id: 'reactflow__edge-' + guid7(),
            source: i + '',
            target: i + 1 + '',
            sourceHandle: 'output',
            targetHandle: 'input',
            type: 'smoothstep',
            style: { strokeWidth: 2, stroke: inAColors.primary[900] },
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,
                height: 20,
                color: inAColors.primary[900],
            }
        }

        if (i === workflow.steps.length - 1) {
            edge.target = 'endOfWorkflow'
        }
        if (step.type + '' === '3') {
            edge.sourceHandle = 'yes'
            edge.target = step.yes > -1 ? step.yes + '' : step.yes == -1 ? i + 1 + '' : 'endOfWorkflow'

            translatedFlow.edges.push({
                id: 'reactflow__edge-no-' + guid7(),
                source: i + '',
                target: step.no > -1 ? step.no + '' : step.no == -1 ? i + 1 + '' : 'endOfWorkflow',
                sourceHandle: 'no',
                targetHandle: 'input',
                type: 'smoothstep',
                style: { strokeWidth: 2, stroke: inAColors.primary[900] },
                markerEnd: {
                    type: MarkerType.ArrowClosed,
                    width: 20,
                    height: 20,
                    color: inAColors.primary[900],
                }
            })
        } else if (step.goto) {
            if (step.goto + '' === '-2') {
                edge.target = 'endOfWorkflow'
            } else {
                edge.target = step.goto + ''
            }
        }

        translatedFlow.edges.push(edge)

        switch (step.type + '') {
            case '0':
                translatedFlow.nodes.push(
                    {
                        id: i + '',
                        data: {
                            title: step.title,
                            description: step.text,
                            media: step.media.filter(media => typeof media != 'string' || !media.startsWith('file://')),
                            nodeType: 'doNode',
                            updateNode: () => { },
                            disabled: true
                        },
                        deletable: false,
                        position: { x: 360 * i + 360, y: 250 },
                        type: 'doNode',
                    }
                )
                break;
            case '1':
                translatedFlow.nodes.push(
                    {
                        id: i + '',
                        data: {
                            title: step.title,
                            description: step.text,
                            media: step.media.filter(media => typeof media != 'string' || !media.startsWith('file://')),
                            listElementMedia: createListElementMedia(i, step.check),
                            nodeType: 'checklistNode',
                            elements: step.check?.length > 0 ? step.check.map((element, index) => {
                                return {
                                    id: i + 'element' + index,
                                    title: element.title,
                                    description: element.text
                                }
                            }) : [],
                            updateNode: () => { },
                            disabled: true
                        },
                        deletable: false,
                        position: { x: 360 * i + 360, y: 250 },
                        type: 'checklistNode',
                    }
                )
                break;
            case '2':
                translatedFlow.nodes.push(
                    {
                        id: i + '',
                        data: {
                            title: step.title,
                            description: step.text,
                            media: step.media.filter(media => typeof media != 'string' || !media.startsWith('file://')),
                            nodeType: 'waitNode',
                            timer: (Math.floor(step.timer / 3600) < 10 ? '0' : '') + Math.floor(step.timer / 3600) + (Math.floor((step.timer % 3600) / 60) < 10 ? ':0' : ':') + Math.floor((step.timer % 3600) / 60) + (Math.floor((step.timer % 3600) % 60) < 10 ? ':0' : ':') + Math.floor((step.timer % 3600) % 60),
                            updateNode: () => { },
                            disabled: true
                        },
                        deletable: false,
                        position: { x: 360 * i + 360, y: 250 },
                        type: 'waitNode',
                    }
                )
                break;
            case '3':
                translatedFlow.nodes.push(
                    {
                        id: i + '',
                        data: {
                            title: step.title,
                            description: step.text,
                            media: step.media.filter(media => typeof media != 'string' || !media.startsWith('file://')),
                            nodeType: 'decideNode',
                            updateNode: () => { },
                            disabled: true
                        },
                        deletable: false,
                        position: { x: 360 * i + 360, y: 250 },
                        type: 'decideNode',
                    }
                )
                break;
        }
    }

    return translatedFlow
}


function createListElementMedia(id, stepElements) {
    let listElementMedia = {}
    for (let i = 0; i < stepElements?.length; i++) {
        listElementMedia[id + 'element' + i] = stepElements[i].media
    }
    return listElementMedia
}
